import pxToEm from '@shared/components/mixins/shared/pxToEm'
import genericContentItem from '@shared/components/mixins/genericContentItem'
import { countdownType } from './_meta'

export default {
  name: 'CountdownComponent',
  mixins: [pxToEm, genericContentItem],
  data() {
    return {
      countdownTime: 0,
      intervalId: null,
      targetTime: null,
    }
  },
  computed: {
    formattedCountdown() {
      const totalSeconds = this.countdownTime
      const days = Math.floor(totalSeconds / 86400)
      const hours = Math.floor((totalSeconds % 86400) / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      return {
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      }
    },
    computedNumberContainerStyle() {
      return {
        borderWidth: this.emStyling.borderWidth,
        borderRadius: this.emStyling.borderRadius,
        borderColor: this.emStyling.borderColor,
        backgroundColor: this.emStyling.backgroundColor,
      }
    },
    computedTimeLabelStyle() {
      const baseFontSize = parseFloat(this.emStyling.fontSize) || 1 // Default to 16px if not set
      const labelFontSize = baseFontSize * 0.4 // 600% less
      return {
        fontSize: `${labelFontSize}em`,
      }
    },
  },

  watch: {
    // Whenever any of these settings change, re-run the countdown logic
    'component.settings.timerType': 'reInitializeCountdown',
    'component.settings.fixedExpiration': 'reInitializeCountdown',
    'component.settings.individualDuration': 'reInitializeCountdown',
    'component.settings.timezone': 'reInitializeCountdown',
  },

  methods: {
    reInitializeCountdown() {
      // Stop old countdown, re-calc the target, and start new countdown
      this.stopCountdown()
      this.calculateRemainingTime()
    },

    calculateRemainingTime() {
      const now = Date.now()
      let target

      if (this.component.settings.timerType ===
        countdownType.FIXED_EXPIRATION) {
        target = new Date(this.component.settings.fixedExpiration)
        if (this.component.settings.timezone) {
          target = this.convertToTimezone(target,
            this.component.settings.timezone)
        }
      } else if (this.component.settings.timerType ===
        countdownType.INDIVIDUAL_COUNTDOWN) {
        const totalSeconds = this.component.settings.individualDuration || 0
        target = new Date(now + totalSeconds * 1000)
      }

      this.targetTime = target.getTime()
      this.updateCountdown()

      // If you want the countdown to also run in the editor, REMOVE this check
      if (this.isEditor) {
        return
      }

      if (!this.intervalId) {
        this.intervalId = setInterval(this.updateCountdown, 1000)
      }
    },

    updateCountdown() {
      const now = Date.now()
      let remaining = Math.floor((this.targetTime - now) / 1000)
      if (remaining <= 0) {
        remaining = 0
        this.countdownTime = 0
        this.stopCountdown()
        this.$emit('countdown-finished')
      } else {
        this.countdownTime = remaining
      }
    },

    stopCountdown() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },

    convertToTimezone(date, timezoneCode) {
      // 1) Convert the given Date to a “localized” string in the target time zone.
      // 2) Parse that localized string back into a new Date object.
      //
      // NOTE: This approach depends on the browser's Intl support and can fail
      // if `timezoneCode` is unrecognized or environment is older.

      try {
        // Convert date to that time zone’s local time in string form
        const localeString = date.toLocaleString('en-US',
          { timeZone: timezoneCode })

        // Recreate a Date object using that localized string
        const convertedDate = new Date(localeString)

        return convertedDate
      } catch (error) {
        console.warn(
          `Timezone conversion failed or not supported for "${timezoneCode}":`,
          error,
        )
        // Fallback: return original date if conversion fails
        return date
      }
    },
  },

  mounted() {
    this.calculateRemainingTime()
  },

  beforeDestroy() {
    this.stopCountdown()
  },
}